export default __webpack_public_path__ + "static/media/KZ.T.09.2216.f7bf3c5b.svg";